import React from 'react';
import { makeStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Box from '@material-ui/core/Box';
import Slide from '@material-ui/core/Slide';

const useStyles = makeStyles((theme) => ({
  alertPaper: {
    minWidth: '300px',
    borderRadius: theme.spacing(2),
    overflow: 'hidden',
  },
  alertTitle: {
    padding: theme.spacing(1.5, 2),
    backgroundColor: '#eac13e',
  },
  alertContent: {
    padding: theme.spacing(2, 3),
  },
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />); // eslint-disable-line

const Alert = ({
  isOpen,
  title,
  content,
  buttons,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      classes={{
        paper: classes.alertPaper,
      }}
      open={isOpen}
      TransitionComponent={Transition}
    >
      <DialogTitle className={classes.alertTitle}>
        <Box
          fontWeight="fontWeightBold"
          fontSize="h6.fontSize"
          textAlign="center"
        >
          {title}
        </Box>
      </DialogTitle>
      <DialogContent className={classes.alertContent}>
        <Box fontSize="body1.fontSize" textAlign="center">
          {content}
        </Box>
      </DialogContent>
      <DialogActions>
        {buttons}
      </DialogActions>
    </Dialog>
  );
};

export default Alert;
